import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons'
import { MenuModule } from '@syncfusion/ej2-angular-navigations';
import { DaylilyLayoutComponent } from './daylily-layout/daylily-layout.component';
import { FeedLayoutComponent } from './feed-layout/feed-layout.component';
import { BreastfeedingComponent } from '../breastfeeding/breastfeeding.component';
import { ClassesComponent } from '../classes/classes.component';
import { RequestAppointmentComponent } from '../request-appointment/request-appointment.component';
import { ResourcesComponent } from '../resources/resources.component';
import { FeatureComponent } from '../wordpress-resources/feature/feature.component';
import { ContactFormComponent } from '../contact-form/contact-form.component';
import { AboutComponent } from '../about/about.component';
import { HomeComponent } from '../home/home.component';
import { TlnInfoComponent } from '../tln-info/tln-info.component';
import { FeedModule } from '../feed/feed.module'; 

@NgModule({
  declarations: [
    DaylilyLayoutComponent,
    FeedLayoutComponent 
  ],
  imports: [
    CommonModule,
    FormsModule,
    DropDownListModule,
    DropDownButtonModule,
    MenuModule,
    FeedModule,
    RouterModule.forChild([]),
    BreastfeedingComponent,
    ClassesComponent, 
    RequestAppointmentComponent, 
    ResourcesComponent,
    ContactFormComponent,
    AboutComponent,
    HomeComponent,
    FeatureComponent,
    TlnInfoComponent
  ],
  exports: [
    DaylilyLayoutComponent,
    FeedLayoutComponent
  ]
})
export class LayoutModule {}
